import React from 'react';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function QuickWin() {
  const {
    t
  } = useLanguage();
  const wins = t.quickWin.items;
  return <Section background="charcoal" className="border-t border-luxury-gold/10" data-id="element-139">
      <div className="max-w-4xl mx-auto" data-id="element-140">
        <div className="text-center mb-12" data-id="element-141">
          <h2 className="font-serif text-3xl md:text-4xl text-white mb-4" data-id="element-142">
            {t.quickWin.headline.line1}{' '}
            <span className="text-luxury-gold italic" data-id="element-143">
              {t.quickWin.headline.span}
            </span>
          </h2>
          <p className="text-luxury-gray font-light" data-id="element-144">
            {t.quickWin.subheadline}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-145">
          {wins.map((win, i) => <div key={i} className="flex items-center p-6 bg-luxury-black/40 border border-white/5 hover:border-luxury-gold/30 transition-colors duration-300" data-id="element-146">
              <div className="flex-shrink-0 mr-4" data-id="element-147">
                <div className="w-8 h-8 rounded-full bg-luxury-gold/10 flex items-center justify-center" data-id="element-148">
                  <Check className="w-4 h-4 text-luxury-gold" data-id="element-149" />
                </div>
              </div>
              <span className="text-white text-lg font-light" data-id="element-150">{win}</span>
            </div>)}
        </div>
      </div>
    </Section>;
}